// Один значок числа на всю оболочку: у пункта меню и в заголовке плашки «Потребує уваги».
// Размер, шрифт и заливка — здесь; нейтральное число стоит на видимой подложке с границей
// (`sunken` на подложке меню едва виден), тревожное — на своей заливке.

const PILL = "inline-flex h-4 min-w-4 shrink-0 items-center justify-center whitespace-nowrap rounded-full px-1 text-2xs font-medium tabular-nums";

export function pillClass(tone: "alarm" | "neutral"): string {
  return `${PILL} ${tone === "alarm" ? "bg-alarm-wash text-alarm-ink" : "border border-line bg-raised text-ink-2"}`;
}
